import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Base } from './Base.js';
import { Number as NumberT } from './Number.js';
import * as utils from './utils.js';
export var BufferT = /*#__PURE__*/function (_Base) {
  _inherits(BufferT, _Base);
  var _super = _createSuper(BufferT);
  function BufferT(length) {
    var _this;
    _classCallCheck(this, BufferT);
    _this = _super.call(this);
    _this.length = length;
    return _this;
  }
  _createClass(BufferT, [{
    key: "decode",
    value: function decode(stream, parent) {
      var length = utils.resolveLength(this.length, stream, parent);
      return stream.readBuffer(length);
    }
  }, {
    key: "size",
    value: function size(val, parent) {
      if (!val) {
        return utils.resolveLength(this.length, null, parent);
      }
      var len = val.length;
      if (this.length instanceof NumberT) {
        len += this.length.size();
      }
      return len;
    }
  }, {
    key: "encode",
    value: function encode(stream, buf, parent) {
      if (this.length instanceof NumberT) {
        this.length.encode(stream, buf.length);
      }
      return stream.writeBuffer(buf);
    }
  }]);
  return BufferT;
}(Base);
export { BufferT as Buffer };